import React, { useState } from "react";
import "./Projects.css";
import { projectsData1 } from "./projectArray";
import default_image from '../../assets/default_image.jpg'

// Reusable Project Card Component
const ProjectCard = ({ title, description, img, techIcons, liveLink, codeLink, days, alt }) => (
  <div className="projects_container" data-aos="fade-right">
    <article className="project">
      <div className="project_videocontainer">
        <div className="newset">
          <img
            className="newsetimg"
            src={img}
            alt={alt || `${title} — project by Aman Jaiswal, frontend developer`}
            loading="lazy"
            decoding="async"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = default_image;
            }}
          />
        </div>
      </div>
      <div className="project_information">
        <h3>{title}</h3>
        <p>{description} <br /><br />{days}</p>
        <div className="tech-icons">
          {techIcons.map((Icon, idx) => (
            <Icon key={idx} aria-hidden="true" />
          ))}
        </div>
        <div className="project-buttons">
          {liveLink && (
            <a
              href={liveLink}
              target="_blank"
              rel="noreferrer"
              aria-label={`Open the live ${title} project built by Aman Jaiswal`}
              title={`${title} — live site`}
            >
              <span className="btns onbt">See this Live</span>
            </a>
          )}
          {codeLink && (
            <a
              href={codeLink}
              target="_blank"
              rel="noreferrer"
              aria-label={`View the source code of ${title} on Aman Jaiswal's GitHub`}
              title={`${title} — source code on GitHub`}
            >
              <span className="btns onbt">View Code</span>
            </a>
          )}
        </div>
      </div>
    </article>
  </div>
);

// Main Project Component
export const Projects = () => {
  const [activeTab, setActiveTab] = useState("all");

  const tabs = [
    { label: "All Projects", key: "all" },
    { label: "Client Projects", key: "client" },
    { label: "Angular Projects", key: "angular" },
    { label: "React Projects", key: "react" },
    { label: "Javascript Projects", key: "javascript" },
  ];

  const projectsData = projectsData1;

  const filteredProjects = activeTab === "all"
    ? projectsData
    : projectsData.filter(project => {
      const langs = Array.isArray(project.language) ? project.language : [project.language];
      return langs.includes(activeTab);
    });

  return (
    <>
      <div className="section-p">
        <h2 className="section__title different" id="projects-heading">
          Projects by Aman Jaiswal
        </h2>
        <p className="projects-intro">
          A selection of Angular, React and JavaScript projects I have built —
          client products shipped as a frontend Angular developer, plus personal
          builds in React and vanilla JavaScript.
        </p>

        {/* Tab Buttons */}
        <div className="tabs" role="group" aria-label="Filter projects by technology">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              type="button"
              className={`tab-button ${activeTab === tab.key ? "active-tab" : ""}`}
              onClick={() => setActiveTab(tab.key)}
              aria-pressed={activeTab === tab.key}
              title={`Show ${tab.label.toLowerCase()} by Aman Jaiswal`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Project Cards */}
        <div className="allProjects">
          {filteredProjects.length === 0 ? (
            <div className="coming-soon-container">
              <div className="coming-soon-text">
                <span>C</span>
                <span>O</span>
                <span>M</span>
                <span>I</span>
                <span>N</span>
                <span>G</span>
                <span className="space"> </span>
                <span>S</span>
                <span>O</span>
                <span>O</span>
                <span>N</span>
                <span>.</span>
                <span>.</span>
                <span>.</span>
              </div>
            </div>
          ) : (
            filteredProjects.map((project, idx) => <ProjectCard key={idx} {...project} />)
          )}
        </div>
      </div>
    </>
  );
};
